import React, {FC} from "react";
import {YhBox} from "../YhBox";
import {Row} from "antd";
import {__FormItem as FormItem} from "./item";
import {IYhFormItemsBox} from "./Types";


export const __FormItemsBox: FC<IYhFormItemsBox> = ({items,justify="start",IclassName,disabled,...props}) => {
    return <YhBox {...props}>
        <Row 
            className={IclassName}
            gutter={[20, 10]}
            justify={justify}
        >
            {items.map((el, index) => <FormItem key={index} {...el} disable={disabled || el.disable }/>)}
        </Row>
    </YhBox>
}
